import React from 'react';
import { Box, Text, TextExtendedProps } from '@common-fe/common-fe';

interface Props extends TextExtendedProps {
  testId: string;
  children: React.ReactNode;
  title: string;
}

const EnrollmentDetailsItem: React.FC<Props> = ({ testId, children, title, ...rest }) => {
  if (!children) {
    return null;
  }
  return (
    <Box
      direction="row"
      height={{ min: '28px' }}
      align="center"
      data-testId={`${testId}_field-wrapper`}
      justify="between"
    >
      <Text size="medium" data-testId={`${testId}_title`} weight={700}>
        {title}
      </Text>
      <Text size="medium" data-testId={`${testId}_value`} weight={400} {...rest}>
        {children}
      </Text>
    </Box>
  );
};
export default EnrollmentDetailsItem;
